.custom-page {
  --content-max: 1500px;
  --container-pad: clamp(16px, 4vw, 48px);

  .page {
    width: 100%;
    min-height: 100%;
    background-color: rgba(255, 255, 255, 1);
  }

  .custom-hero {
    position: relative;
    width: 100%;
    min-height: clamp(620px, 78vh, 920px);
    background: url(../../../assets/images/pages-products-custom-custom-hero.png)
      no-repeat center / cover;
    overflow: hidden;
  }

  .custom-hero__overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(22, 0, 4, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .custom-hero__content {
    width: min(92vw, var(--content-max));
    margin: auto auto clamp(52px, 18vh, 260px);
    padding: 0 var(--container-pad);
    box-sizing: border-box;
    text-align: center;
  }

  .custom-hero__title {
    margin: 0;
    color: rgba(255, 255, 255, 1);
    font-size: clamp(40px, 8vw, 120px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    line-height: 1.04;
  }

  .custom-hero__lead {
    margin: clamp(16px, 2.6vw, 30px) auto 0;
    width: min(100%, 80ch);
    color: rgba(255, 255, 255, 1);
    font-size: clamp(15px, 1.35vw, 24px);
    font-family: Red Rose-Light;
    font-weight: 300;
    line-height: 1.65;
  }

  .custom-advantages {
    width: 100%;
    padding: clamp(56px, 9vw, 160px) var(--container-pad) clamp(64px, 10vw, 140px);
    box-sizing: border-box;
  }

  .custom-advantages__title {
    margin: 0;
    text-align: center;
    text-transform: uppercase;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(36px, 5.3vw, 80px);
    font-family: Red Rose-SemiBold;
    font-weight: normal;
    line-height: 1;
  }

  .custom-advantages__grid {
    width: min(100%, var(--content-max));
    margin: clamp(36px, 5vw, 96px) auto 0;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: clamp(18px, 2vw, 32px);
  }

  .advantage-card {
    min-width: 0;
  }

  .advantage-card__icon {
    width: clamp(60px, 5.2vw, 96px);
    height: clamp(60px, 5.2vw, 96px);
    object-fit: contain;
    display: block;
  }

  .advantage-card__title {
    margin: clamp(18px, 2.1vw, 28px) 0 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(21px, 1.65vw, 32px);
    font-family: Red Rose-Medium;
    font-weight: 500;
    line-height: 1.2;
  }

  .advantage-card__description {
    margin: 14px 0 0;
    color: rgba(124, 124, 124, 1);
    font-size: clamp(14px, 1vw, 16px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    line-height: 1.6;
  }

  .custom-contact-hero {
    width: 100%;
    min-height: clamp(520px, 72vh, 980px);
    background: url(../../../assets/images/pages-products-custom-custom-contact-hero.png)
      no-repeat center / cover;
  }

  .custom-contact-hero__overlay {
    min-height: inherit;
    background-color: rgba(22, 0, 4, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: clamp(56px, 9vh, 110px) var(--container-pad);
    box-sizing: border-box;
  }

  .custom-contact-hero__content {
    width: min(92vw, 1120px);
    text-align: center;
  }

  .custom-contact-hero__title {
    margin: 0;
    color: rgba(255, 255, 255, 1);
    font-size: clamp(48px, 10vw, 160px);
    font-family: Red Rose-Regular;
    font-weight: normal;
    line-height: 1;
  }

  .custom-contact-hero__lead {
    margin: clamp(14px, 2.1vw, 30px) auto 0;
    max-width: 72ch;
    color: rgba(255, 255, 255, 1);
    font-size: clamp(15px, 1.35vw, 24px);
    font-family: Red Rose-Light;
    font-weight: 300;
    line-height: 1.65;
  }

  .custom-contact-info {
    width: 100%;
    max-width: var(--content-max);
    margin: 0 auto;
    padding: 24px var(--container-pad) 28px;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: clamp(20px, 3.2vw, 56px);
    align-items: start;
  }

  .custom-contact-info__item {
    display: flex;
    align-items: baseline;
    gap: clamp(14px, 2vw, 32px);
    min-width: 0;
  }

  .custom-contact-info__label {
    flex: 0 0 auto;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(20px, 1.7vw, 32px);
    font-family: Red Rose-Regular;
    line-height: 1.1;
  }

  .custom-contact-info__value {
    margin: 0;
    color: rgba(22, 0, 4, 1);
    font-size: clamp(16px, 1.5vw, 32px);
    font-family: Red Rose-Regular;
    line-height: 1.3;
    text-decoration: none;
    font-style: normal;
    word-break: break-word;
  }

  .custom-contact-info__value[href]:hover {
    text-decoration: underline;
  }

  @media (max-width: 1279px) {
    .custom-advantages__grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  @media (max-width: 1023px) {
    .custom-hero {
      min-height: clamp(560px, 72vh, 760px);
    }

    .custom-advantages__grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .custom-contact-info {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 767px) {
    .custom-hero {
      min-height: clamp(520px, 70vh, 680px);
    }

    .custom-hero__content {
      margin-bottom: clamp(36px, 12vh, 150px);
    }

    .custom-advantages__grid {
      grid-template-columns: 1fr;
    }

    .custom-contact-info__item {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }
}
